export class RegexConstants {
    public static Patterns = {
        // eslint-disable-next-line no-control-regex
        EmailRfc5322: /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:)\])$/
    };

    //Escape square brackets in a string
    static escapeSquareBrackets(value: string): string {
		// checks for [] and for \[ \] to escape them. only replaces if there is an nothing or an even number of \ before the [ or ]
        return  value.replace(/(?:(?<!\\)(?:\\\\)*)[[\]]/g, '\\$&');
    }
}
